const options = ({ title, series }) => ({
  chart: {
    type: 'line',
    zoomType: 'x',
    panning: true,
    panKey: 'shift',
    spacingTop: 20,
    resetZoomButton: {
      relativeTo: 'chart',
    },
  },
  colors: [
    '#0747A6', '#0d233a', '#8bbc21', '#910000',
    '#1aadce', '#492970', '#f28f43', '#77a1e5',
  ],
  credits: {
    enabled: false,
  },
  exporting: {
    filename: 'rbs-report',
    printMaxWidth: 1920,
  },
  title: {
    text: title,
  },
  yAxis: {
    title: {
      text: '',
    },
  },
  xAxis: {
    type: 'datetime',
    title: {
      text: '',
    },
  },
  plotOptions: {
    line: {
      turboThreshold: 0,
      marker: {
        enabled: false,
        symbol: 'circle',
        radius: 2,
        states: {
          hover: {
            enabled: true,
          },
        },
      },
    },
  },
  tooltip: {
    headerFormat: '<span style="font-size: 12px">{point.key}</span><br/>',
    backgroundColor: '#ffffff',
    borderWidth: 0,
    borderRadius: 3,
    enabled: true,
    shared: true,
    padding: 10,
  },
  series,
});

export default options;
